import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["target", "rel", "download", "onClick", "onKeyDown", "onMouseDown", "onMouseUp", "tabIndex", "role"];
import { c as _c } from "react-compiler-runtime";
import { useState } from 'react';
import { getSafeUrl } from '../../utils/isUnsafeUrl';
/**
 * Provides link behavior and accessibility for navigation elements.
 * Handles keyboard interactions (Enter only), disabled state, and press events.
 * Supports rendering as different element types (a, span, div, custom components). See useButton for building Button components.
 */
export function useLink(t0) {
  const $ = _c(53);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    href,
    isDisabled: t2,
    onPress,
    onPressStart,
    onPressEnd,
    elementType: t3,
    ref: forwardedRef,
    props: t4
  } = options;
  const isDisabled = t2 === undefined ? false : t2;
  const elementType = t3 === undefined ? "a" : t3;
  let t5;
  if ($[2] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let download;
  let onClick;
  let onKeyDown;
  let onMouseDown;
  let onMouseUp;
  let rel;
  let restProps;
  let role;
  let tabIndex;
  let target;
  if ($[4] !== t5) {
    var _t = t5;
    ({
      target,
      rel,
      download,
      onClick,
      onKeyDown,
      onMouseDown,
      onMouseUp,
      tabIndex,
      role
    } = _t);
    restProps = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[4] = t5;
    $[5] = download;
    $[6] = onClick;
    $[7] = onKeyDown;
    $[8] = onMouseDown;
    $[9] = onMouseUp;
    $[10] = rel;
    $[11] = restProps;
    $[12] = role;
    $[13] = tabIndex;
    $[14] = target;
  } else {
    download = $[5];
    onClick = $[6];
    onKeyDown = $[7];
    onMouseDown = $[8];
    onMouseUp = $[9];
    rel = $[10];
    restProps = $[11];
    role = $[12];
    tabIndex = $[13];
    target = $[14];
  }
  const [isPressed, setIsPressed] = useState(false);
  const isNativeLink = elementType === "a";
  const linkRel = rel || (target === "_blank" ? "noopener noreferrer" : undefined);
  let t6;
  if ($[15] !== isDisabled || $[16] !== onPress) {
    t6 = e => {
      if (isDisabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      onPress === null || onPress === void 0 || onPress(e);
    };
    $[15] = isDisabled;
    $[16] = onPress;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const handleClick = t6;
  let t7;
  if ($[18] !== href || $[19] !== isDisabled || $[20] !== isNativeLink || $[21] !== onPress) {
    t7 = e_0 => {
      if (isDisabled) {
        e_0.preventDefault();
        return;
      }
      if (e_0.key === "Enter") {
        if (!isNativeLink || !href) {
          e_0.preventDefault();
          onPress === null || onPress === void 0 || onPress(e_0);
        }
      }
    };
    $[18] = href;
    $[19] = isDisabled;
    $[20] = isNativeLink;
    $[21] = onPress;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const handleKeyDown = t7;
  let t8;
  if ($[23] !== isDisabled || $[24] !== onPressStart) {
    t8 = e_1 => {
      if (isDisabled) {
        return;
      }
      setIsPressed(true);
      onPressStart === null || onPressStart === void 0 || onPressStart(e_1);
    };
    $[23] = isDisabled;
    $[24] = onPressStart;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const handleMouseDown = t8;
  let t9;
  if ($[26] !== isDisabled || $[27] !== isPressed || $[28] !== onPressEnd) {
    t9 = e_2 => {
      if (isDisabled) {
        return;
      }
      if (isPressed) {
        setIsPressed(false);
        onPressEnd === null || onPressEnd === void 0 || onPressEnd(e_2);
      }
    };
    $[26] = isDisabled;
    $[27] = isPressed;
    $[28] = onPressEnd;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  const handleMouseUp = t9;
  const disabledClick = _temp;
  const disabledKeyDown = _temp2;
  let t10;
  if ($[30] !== download || $[31] !== forwardedRef || $[32] !== handleClick || $[33] !== handleKeyDown || $[34] !== handleMouseDown || $[35] !== handleMouseUp || $[36] !== href || $[37] !== isDisabled || $[38] !== isNativeLink || $[39] !== linkRel || $[40] !== onClick || $[41] !== onKeyDown || $[42] !== onMouseDown || $[43] !== onMouseUp || $[44] !== restProps || $[45] !== role || $[46] !== tabIndex || $[47] !== target) {
    t10 = () => {
      var _tabIndex;
      const composeHandlers = _temp3;
      const commonProps = Object.assign({
        ref: forwardedRef,
        tabIndex: isDisabled ? -1 : (_tabIndex = tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
        onClick: isDisabled ? disabledClick : composeHandlers(onClick, handleClick),
        onKeyDown: isDisabled ? disabledKeyDown : composeHandlers(onKeyDown, handleKeyDown),
        onMouseDown: isDisabled ? undefined : composeHandlers(onMouseDown, handleMouseDown),
        onMouseUp: isDisabled ? undefined : composeHandlers(onMouseUp, handleMouseUp)
      }, restProps, {
        "aria-disabled": isDisabled || undefined,
        "data-disabled": isDisabled || undefined
      });
      if (isNativeLink) {
        return Object.assign({}, commonProps, {
          role: !href || isDisabled ? "link" : role,
          href: isDisabled ? undefined : getSafeUrl(href),
          target: isDisabled ? undefined : target,
          rel: linkRel,
          download
        });
      }
      return Object.assign({}, commonProps, {
        role: "link"
      });
    };
    $[30] = download;
    $[31] = forwardedRef;
    $[32] = handleClick;
    $[33] = handleKeyDown;
    $[34] = handleMouseDown;
    $[35] = handleMouseUp;
    $[36] = href;
    $[37] = isDisabled;
    $[38] = isNativeLink;
    $[39] = linkRel;
    $[40] = onClick;
    $[41] = onKeyDown;
    $[42] = onMouseDown;
    $[43] = onMouseUp;
    $[44] = restProps;
    $[45] = role;
    $[46] = tabIndex;
    $[47] = target;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  const getLinkProps = t10;
  let t11;
  if ($[49] !== getLinkProps || $[50] !== isDisabled || $[51] !== isPressed) {
    t11 = {
      getLinkProps,
      isDisabled,
      isPressed
    };
    $[49] = getLinkProps;
    $[50] = isDisabled;
    $[51] = isPressed;
    $[52] = t11;
  } else {
    t11 = $[52];
  }
  return t11;
}
function _temp3(userHandler, internalHandler) {
  return e_5 => {
    userHandler === null || userHandler === void 0 || userHandler(e_5);
    internalHandler(e_5);
  };
}
function _temp2(e_4) {
  e_4.preventDefault();
}
function _temp(e_3) {
  e_3.preventDefault();
  e_3.stopPropagation();
}